import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RenaultLogDTO } from '../models/renault-log-dto';
import { RenaultLocalCampaignOrderDataViewContentDTO } from '../models/renault-local-campaign-order-data-dto';
import { RenaultCampaignCrmClientEmailViewContentDTO } from '../models/renault-campaign-crm-client-dto';
import { RenaultPuntoapuntoLocalCampaignOrderDataViewContentDTO } from '../models/renault-puntoapunto-local-campaign-order';

@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  private pathAPI = environment.urlAPI;
  private controller = "Tracking/";

  constructor(private http: HttpClient) { }

  public trackUser(data: RenaultLogDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "TrackUser", data);
  }

  public viewLocalCampaign(idOrderData: string): Observable<RenaultLocalCampaignOrderDataViewContentDTO> {
    return this.http.get<RenaultLocalCampaignOrderDataViewContentDTO>(this.pathAPI + this.controller + "ViewLocalCampaign/" + idOrderData);
  }

  public viewCampaignCrmEmail(idOrderData: string): Observable<RenaultCampaignCrmClientEmailViewContentDTO> {
    return this.http.get<RenaultCampaignCrmClientEmailViewContentDTO>(this.pathAPI + this.controller + "ViewCampaignCrmEmail/" + idOrderData);
  }

  public ViewCrmPapEmail(idOrderData: string): Observable<RenaultPuntoapuntoLocalCampaignOrderDataViewContentDTO> {
    return this.http.get<RenaultPuntoapuntoLocalCampaignOrderDataViewContentDTO>(this.pathAPI + this.controller + "ViewCrmPapEmail/" + idOrderData);
  }

  public TrackStaticDocument(docName: string, url: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "TrackStaticDocument?docName=" + docName + "&url=" + url);
  }

  public TrackDocument(idDocument: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "TrackDocument?idDocument=" + idDocument);
  }

}
